import React, {Component} from 'react';
import '../../styles/Home.css'
import {Button} from "react-bootstrap";
import LoginService from "../../admin/loginComponents/LoginService";
import {Link, withRouter} from "react-router-dom";
import Konto from "../Konto";
import {NotificationManager} from "react-notifications";

class KontoComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            login: '',
            pass: '',
        };

        this.handleLogin = this.handleLogin.bind(this);
        this.handlePass = this.handlePass.bind(this);
        this.keyPress = this.keyPress.bind(this)
    }

    componentDidMount() {
        this.nameInput.focus();
        if (this.props.zmianaHasla){
            NotificationManager.info('Zaloguj się ponownie używając nowego hasła', 'Informacja', 5000);
        }
    }

    keyPress(e) {
        if (e.keyCode === 13) {
            this.onLogin()
        }
    }

    handleLogin(e) {
        this.setState({login: e.target.value})
    }

    handlePass(e) {
        this.setState({pass: e.target.value})
    }

    onLogin() {
        LoginService.postLogin(this.state.login, this.state.pass)
            .then(function (response) {
                if (response.status === 200) {
                    LoginService.getKlient(response.data.idKl, this.state.login, this.state.pass).then(function (response) {
                        sessionStorage.setItem('loggedIn', JSON.stringify({
                            idKl: response.data.idKl,
                            imie: response.data.imie,
                            nazwisko: response.data.nazwisko,
                            miejscowosc: response.data.miejscowosc,
                            kodPoczt: response.data.kodPoczt,
                            nrDok: response.data.nrDok,
                            nrDomu: response.data.nrDomu,
                            nrMieszk: response.data.nrMieszk,
                            nrDokSprawdzony: response.data.nrDokSprawdzony,
                            nrDokWaznyDo: response.data.nrDokWaznyDo,
                            nrDokSkan: response.data.nrDokSkan,
                            nrTel: response.data.nrTel,
                            pesel: response.data.pesel,
                            ulica: response.data.ulica,
                            pliki: response.data.pliki,
                            login: this.state.login,
                            pass: this.state.pass
                        }));
                        if (sessionStorage.getItem('link') !== null) {
                            window.location.replace(sessionStorage.getItem('link'));
                            sessionStorage.removeItem('link')
                        } else {
                            this.props.history.push("/konto");
                        }
                    }.bind(this))
                }
            }.bind(this))
            .catch(error => {
                console.log(error)
            })
            .catch((e) => {
                console.log(e)
            })
    }

    render() {
        return <Konto>
            <div className="row wynik ramka marginLeftRightMobilka" style={{padding: 50}}>
                <div className="col-12 text-center">
                    <h2><b>Logowanie</b></h2>
                    <div className="inputLogin"><i className="fa fa-user"> </i>
                        <input ref={(input) => {
                            this.nameInput = input;
                        }} className="form-control inputLoginControl" value={this.state.login}
                               onChange={this.handleLogin} onKeyDown={this.keyPress}
                               placeholder="Nazwa użytkownika..."
                               type="text"/></div>
                    <div className="inputLogin"><i className="fa fa-unlock-alt"> </i>
                        <input className="form-control inputLoginControl" value={this.state.pass}
                               onChange={this.handlePass}
                               onKeyDown={this.keyPress} placeholder="Hasło..." type="password"/></div>
                    <div className="buttonLogin"><Button bsStyle="success"
                                                         onClick={() => this.onLogin()}>Zaloguj</Button>
                    </div>
                    <div style={{paddingTop: 25}}>
                        Nie posiadasz jeszcze konta? <Link to={'/register'}><b>Zarejestruj się</b></Link>
                    </div>
                    <div>
                        <Link to={'/password-lost'}><b>Nie pamiętam hasła</b></Link>
                    </div>
                </div>
            </div>
        </Konto>
    }

}

export default withRouter(KontoComponent)



// WEBPACK FOOTER //
// ./src/components/konto/kontoComponents/KontoComponent.js